module.exports = __webpack_public_path__ + "img/DW365-314.cacf7d5f.jpg";